let pendingForm = null;
let pendingInput = null;
let pendingSelectedValue = null;

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.selectedValue = null;
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');

        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('.disclosure > button.disclosure__button') || this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          returnLink: this.querySelector('.return_link'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          overlay: this.querySelector('.country-selector__overlay'),
          dropdownBtn: this.querySelector('.selected-option'),
          dropdownOptions: this.querySelector('.dropdown-options'),
          goBtn: this.querySelector('.go_btn'),
        };

        this.syncHeaderFlag();

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));

        if (this.elements.button) {
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }

        if (this.elements.returnLink) {
          this.elements.returnLink.addEventListener('click', this.hidePanel.bind(this));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        if (this.elements.overlay) {
          this.elements.overlay.addEventListener('click', this.hidePanel.bind(this));
        }

        // Inner country dropdown toggling
        if (this.elements.dropdownBtn) {
          this.elements.dropdownBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleDropdown();
          });
        }

        // Dropdown country options click handler
        if (this.elements.dropdownOptions) {
          this.elements.dropdownOptions.querySelectorAll('.disclosure__link').forEach((link) => {
            link.addEventListener('click', this.onCountryOptionClick.bind(this));
          });
        }

        // Language / direct link options (outside the custom site selector dropdown)
        this.querySelectorAll('.disclosure__list a.disclosure__link').forEach((item) => {
          item.addEventListener('click', this.onLanguageItemClick.bind(this));
        });

        // "Go" button handler
        if (this.elements.goBtn) {
          this.elements.goBtn.addEventListener('click', this.onItemClickUpdate.bind(this));
        }

        // Document click handler to close dropdown when clicking outside
        this.onDocClick = (event) => {
          if (
            this.isDropdownOpen() &&
            this.elements.dropdownBtn &&
            !this.elements.dropdownBtn.contains(event.target) &&
            this.elements.dropdownOptions &&
            !this.elements.dropdownOptions.contains(event.target)
          ) {
            this.closeDropdown();
          }
        };
        document.addEventListener('click', this.onDocClick);
      }

      // The market the visitor actually has selected. Shopify keeps it in the
      // "localization" cookie, which is right even when the page HTML came
      // from a cache; the Liquid-rendered values are the fallback.
      getActiveCountryIso() {
        const cookie = document.cookie.match(/(?:^|;\s*)localization=([A-Za-z]{2})/);
        if (cookie) return cookie[1].toUpperCase();
        if (window.Shopify && window.Shopify.country) return String(window.Shopify.country).toUpperCase();
        return typeof country_code !== 'undefined' ? String(country_code).toUpperCase() : '';
      }

      // Set flag, label and currency of the header country selector to a
      // market straight away (no reload). Safe to call repeatedly.
      applyMarketFlag(iso) {
        const input = this.querySelector('input[name="country_code"]');
        if (!input || !iso) return; // not the country form
        iso = String(iso).toUpperCase();

        const link = this.querySelector('.dropdown-options .disclosure__link[data-value="' + iso + '"]');
        const name = link ? (link.querySelector('.country') || link).textContent.trim() : '';
        const currency = link ? link.dataset.currencyValue : '';

        [this.elements.button, this.elements.dropdownBtn].forEach((btn) => {
          if (!btn) return;
          btn.setAttribute('data-country', iso);
          if (currency) btn.setAttribute('data-value', currency);
          const span = btn.querySelector('span');
          if (span) {
            const text = btn === this.elements.button ? currency : name;
            if (text) span.textContent = text;
          }
        });

        if (this.elements.dropdownOptions) {
          this.elements.dropdownOptions.querySelectorAll('.dropdown-option').forEach((opt) => {
            const active = !!opt.querySelector('.disclosure__link[data-value="' + iso + '"]');
            opt.classList.toggle('active', active);
            opt.classList.toggle('is-selected', active);
            opt.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }
      }

      // On page load: align the selector with the market the visitor really
      // has selected (cookie), even if the page HTML came from a cache.
      syncHeaderFlag() {
        const iso = this.getActiveCountryIso();
        if (iso) this.applyMarketFlag(iso);
      }

      disconnectedCallback() {
        if (this.onDocClick) {
          document.removeEventListener('click', this.onDocClick);
        }
      }

      isDropdownOpen() {
        return !!(this.elements.dropdownOptions && this.elements.dropdownOptions.classList.contains('is-open'));
      }

      openDropdown() {
        if (!this.elements.dropdownOptions || !this.elements.dropdownBtn) return;
        this.elements.dropdownOptions.classList.add('is-open');
        this.elements.dropdownBtn.classList.add('open-dropdown');
        this.elements.dropdownBtn.setAttribute('aria-expanded', 'true');
      }

      closeDropdown() {
        if (!this.elements.dropdownOptions || !this.elements.dropdownBtn) return;
        this.elements.dropdownOptions.classList.remove('is-open');
        this.elements.dropdownBtn.classList.remove('open-dropdown');
        this.elements.dropdownBtn.setAttribute('aria-expanded', 'false');
      }

      toggleDropdown() {
        if (this.isDropdownOpen()) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      onCountryOptionClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const link = event.currentTarget;
        const countryCode = link.dataset.value;
        const currencyCode = link.dataset.currencyValue;
        const countrySpan = link.querySelector('.country');
        const countryName = countrySpan ? countrySpan.textContent.trim() : link.textContent.trim();

        // Update selected option button text and flag
        if (this.elements.dropdownBtn) {
          const textSpan = this.elements.dropdownBtn.querySelector('span');
          if (textSpan) textSpan.textContent = countryName;
          if (currencyCode) {
            this.elements.dropdownBtn.setAttribute('data-value', currencyCode);
          }
          if (countryCode) {
            this.elements.dropdownBtn.setAttribute('data-country', countryCode);
          }
        }

        // Set input value & data attributes
        if (countryCode) {
          this.setAttribute('data-selected', countryCode);
          this.setAttribute('data-selected-name', countryName);
          if (this.elements.input) {
            this.elements.input.value = countryCode;
          }
        }

        // Update active class in dropdown options
        if (this.elements.dropdownOptions) {
          this.elements.dropdownOptions.querySelectorAll('.dropdown-option').forEach((opt) => {
            opt.classList.remove('active', 'is-selected');
            opt.setAttribute('aria-selected', 'false');
          });
          this.elements.dropdownOptions.querySelectorAll('.disclosure__link').forEach((l) => {
            l.removeAttribute('aria-current');
          });
          const parentOption = link.closest('.dropdown-option');
          if (parentOption) {
            parentOption.classList.add('active', 'is-selected');
            parentOption.setAttribute('aria-selected', 'true');
          }
          link.setAttribute('aria-current', 'true');
        }

        this.closeDropdown();
      }

      onLanguageItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form') || this.closest('form');
        const value = event.currentTarget.dataset.value;
        if (this.elements.input && value) {
          this.elements.input.value = value;
        }
        if (form) form.submit();
      }

      hidePanel() {
        if (this.elements.button) {
          this.elements.button.setAttribute('aria-expanded', 'false');
        }
        if (this.elements.panel) {
          this.elements.panel.setAttribute('hidden', true);
        }
        this.closeDropdown();
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        if (!this.elements.search) return;

        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            if (itemToFocus) itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            if (itemToFocus) itemToFocus.focus();
            break;
        }

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.isDropdownOpen()) {
              event.preventDefault();
              event.stopPropagation();
              this.closeDropdown();
              if (this.elements.dropdownBtn) this.elements.dropdownBtn.focus();
              return;
            }
            if (this.elements.button && this.elements.button.getAttribute('aria-expanded') == 'false') return;
            event.preventDefault();
            event.stopPropagation();
            this.hidePanel();
            if (this.elements.button) this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button && this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClickUpdate(event) {
        event.preventDefault();
        event.stopPropagation();

        const selectedCountryValue = this.getAttribute('data-selected') || (this.elements.input ? this.elements.input.value : '');
        const form = this.querySelector('form') || this.closest('form');
        const input = this.elements.input || this.querySelector('input[name="country_code"]');

        if (!form || !input) return;

        const currentCountryIso = this.getActiveCountryIso() || (typeof country_code !== 'undefined' ? country_code : (input.defaultValue || ''));
        const activeLink = this.querySelector('.dropdown-options .disclosure__link[data-value="' + currentCountryIso + '"]');
        const currentCountry = activeLink
          ? (activeLink.querySelector('.country') || activeLink).textContent.trim()
          : (typeof currentCountryName !== 'undefined' ? currentCountryName : '');
        const dropdownSpan = this.elements.dropdownBtn ? this.elements.dropdownBtn.querySelector('span') : null;
        const newCountryName = this.getAttribute('data-selected-name') || (dropdownSpan ? dropdownSpan.textContent.trim() : '');

        // If user hasn't changed the country, just close the modal
        if (selectedCountryValue && currentCountryIso && selectedCountryValue.toUpperCase() === currentCountryIso.toUpperCase()) {
          this.hidePanel();
          return;
        }

        if (!selectedCountryValue) {
          this.hidePanel();
          return;
        }

        input.value = selectedCountryValue;

        // Save for later confirmation
        pendingForm = form;
        pendingInput = input;
        pendingSelectedValue = selectedCountryValue;
        window.pendingForm = form;
        window.pendingInput = input;
        window.pendingSelectedValue = selectedCountryValue;
        window.pendingLocalizationForm = {
          form,
          input,
          selectedValue: selectedCountryValue
        };

        const modalMessage = document.getElementById("confirmCountryModalMessage");
        if (modalMessage) {
          modalMessage.textContent = `Are you sure you want to switch from the ${currentCountry} site to ${newCountryName} site?`;
        }

        // Open the Bootstrap modal if present
        const confirmModalEl = document.getElementById("confirmModal");
        if (confirmModalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
          const modal = bootstrap.Modal.getInstance(confirmModalEl) || new bootstrap.Modal(confirmModalEl);
          modal.show();
        } else {
          this.applyMarketFlag(selectedCountryValue);
          form.submit();
        }
      }

      openSelector() {
        if (this.elements.button) {
          this.elements.button.focus();
          this.elements.button.setAttribute(
            'aria-expanded',
            (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
          );
        }
        if (this.elements.panel) {
          this.elements.panel.toggleAttribute('hidden');
        }
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          (event.target && event.target.classList && event.target.classList.contains('country-selector__overlay')) ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      filterCountries() {
        if (!this.elements.search) return;
        const searchValue = this.elements.search.value.toLowerCase();
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countrySpan = item.querySelector('.country');
          const countryName = countrySpan ? countrySpan.textContent.toLowerCase() : '';
          if (countryName.indexOf(searchValue) > -1) {
            if (item.parentElement) item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            if (item.parentElement) item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion && window.accessibilityStrings && window.accessibilityStrings.countrySelectorSearchCount) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const selector = this.querySelector('.country-selector');
        if (selector) selector.scrollTop = 0;
        const selectorList = this.querySelector('.country-selector__list');
        if (selectorList) selectorList.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.focus();
        }
      }

      onSearchFocus() {
        if (this.elements.searchIcon) {
          this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
        }
      }

      onSearchBlur() {
        if (this.elements.searchIcon && this.elements.search && !this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

// Update every country selector's flag immediately (used by the confirm modal
// and by the store suggestion popup), without waiting for the page to reload.
window.ddSetMarketFlag = function (iso) {
  document.querySelectorAll('localization-form').forEach(function (el) {
    if (typeof el.applyMarketFlag === 'function') el.applyMarketFlag(iso);
  });
};

// "Yes, switch" in the confirmation modal: update the flag first, then let the
// existing handler (custom.js) submit the form.
document.addEventListener(
  'click',
  function (event) {
    const btn = event.target && event.target.closest ? event.target.closest('#confirmSubmitBtn') : null;
    if (!btn) return;
    const iso = window.pendingSelectedValue || (typeof pendingSelectedValue !== 'undefined' ? pendingSelectedValue : '');
    if (iso) window.ddSetMarketFlag(iso);
  },
  true
);